export const environment = {
  production: false,
  application:
    {
      name: 'Roccavione',
      version: '1.0',
    },

  frontendEndpoint: 'http://localhost:4200/',
  apiUrl: 'http://localhost:4200/'
};
